import { render, staticRenderFns } from "./targets-tables.vue?vue&type=template&id=5255e412&scoped=true"
import script from "./targets-tables.vue?vue&type=script&lang=js"
export * from "./targets-tables.vue?vue&type=script&lang=js"
import style0 from "./targets-tables.vue?vue&type=style&index=0&id=5255e412&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255e412",
  null
  
)

export default component.exports